export const alertGridAreaIcon = 'alert-icon';
export const alertGridAreaTitle = 'alert-title';
export const alertGridAreaContent = 'alert-content';
export const alertGridAreaActions = 'alert-actions';
export const alertGridAreaClose = 'alert-close';
